import { render, staticRenderFns } from "./pc-address.vue?vue&type=template&id=4d3e6bfe&scoped=true&"
import script from "./pc-address.vue?vue&type=script&lang=ts&"
export * from "./pc-address.vue?vue&type=script&lang=ts&"
import style0 from "./pc-address.vue?vue&type=style&index=0&id=4d3e6bfe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3e6bfe",
  null
  
)

export default component.exports